import { ArrowBackIosNewOutlined } from '@mui/icons-material'
import { Box, Stack, Typography } from '@mui/material'
import { FunctionComponent } from 'react'
import { Link } from 'react-router-dom'

const labelTypographySx = {
  p: 0.5,
  color: 'primary.main',
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'underline',
    textDecorationColor: 'primary.main',
  },
} as const

export const BackButtonLink: FunctionComponent<{ link?: string; buttonText: string; onClick?: () => void }> = ({
  link,
  buttonText,
  onClick,
}) => {
  const iconAndText = (
    <>
      <ArrowBackIosNewOutlined sx={{ color: 'primary.main', fontSize: '0.9rem' }} />
      <Typography sx={labelTypographySx}>{buttonText}</Typography>
    </>
  )

  if (link) {
    return (
      <Box
        component={Link}
        to={link}
        onClick={onClick}
        sx={{ textDecoration: 'none', color: 'primary.main', display: 'inline-block' }}
      >
        <Stack display="flex" flexDirection="row" alignItems="center">
          {iconAndText}
        </Stack>
      </Box>
    )
  }

  return (
    <Stack
      component="button"
      type="button"
      onClick={onClick}
      display="flex"
      flexDirection="row"
      alignItems="center"
      sx={{
        border: 'none',
        background: 'none',
        p: 0,
        m: 0,
        cursor: 'pointer',
        font: 'inherit',
        textAlign: 'left',
        color: 'primary.main',
      }}
    >
      {iconAndText}
    </Stack>
  )
}
